import { Row } from "react-bootstrap";
import { RestuarantesStyled } from "./Restuarantes.styled";
import { useHistory } from "react-router-dom";
import { checkIsMobile } from "../../Utills/Utill";
import locationicon from "../../images/cashbach/map-pin-fill.svg";
import directionicon from "../../images/cashbach/direction-fill.svg";
import { useEffect } from "react";
import {
  getAllmerchantsAPI,
  getAllOffersAPI,
} from "../../redux/slices/reports/reportsService";
import { useDispatch, useSelector } from "react-redux";
const Restuarantes = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { allMerchantsList, allOffersList } = useSelector(
    (state: any) => state?.reports
  );
  useEffect(() => {
    dispatch(getAllmerchantsAPI({ id: "68da53018d46074c47d36613" }));
    dispatch(getAllOffersAPI({ id: "68da53018d46074c47d36613" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RestuarantesStyled>
      <div className="main_container all_cate_main_wrapper">
        <div className="head_wrapper">
          <h2 className="ppl_cate_header">Restaurantes</h2>
        </div>
        {allOffersList?.data?.map((item: any) => {
          const merchant = allMerchantsList?.data?.find(
            (m: any) => m?._id === item?.merchantId
          );
          return (
            <Row
              className={`list_wrapper ${
                checkIsMobile() && "mobile-list_wrapper"
              }`}
            >
              <div
                className="card-div"
                onClick={() => history.push("/Restuarante-details/" + item?._id)}
              >
                <div className="image-section">
                  <div className="inner-img-sec">
                    <img src={merchant?.merchantImageUrl} alt="UserIcon" />
                  </div>
                </div>
                <div className="text-section">
                  <h5>{item?.offerName}</h5>
                  <p>{item?.offerDiscription}</p>
                  <div className="location row">
                    <div className="col-6 d-flex location-section">
                      <img src={locationicon} alt="locationicon" />
                      <p>
                        {merchant?.addressline1},{merchant?.addressline2}{" "}
                        {merchant?.addressline2 && ","}
                        {merchant?.city} {merchant?.city && ","}
                        {merchant?.state} {merchant?.state && ","}
                        {merchant?.zipcode} {merchant?.zipcode && ","}
                        {merchant?.country}
                      </p>
                    </div>
                    <div className="col-6 button-section">
                      <button>
                        OBTENER DIRECCIONES
                        <img src={directionicon} alt="locationicon" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          );
        })}
      </div>
    </RestuarantesStyled>
  );
};

export default Restuarantes;
